/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/static-property-placement */
import React from 'react'
import * as H from 'history'
import { Alert } from 'react-bootstrap'
import { ISupportSpinner } from '../../../shared/Ajax'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ApplicationModel } from '../../../models/ApplicationModel'
import ConflictOfInterest from './Components/ConflictOfinterest'
import SupportingDocumention from './Components/SupportingDocumention'
import BankDetails from './Components/BankDetails'
import Declaration from './Components/Declaration'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { TabHeading, validateFields } from '../../../shared/fields'
import { getInvalidFileBlobIds, isEmpty } from '../../../shared/Utility'
import { Backdrop } from '../../../shared/Backdrop'
import { PreviewPage } from '../PreviewPage'
import { ApplicationSubmission } from '../../../models/ApplicationSubmission'
import { Consultant } from '../../../models/Consultant'
import { Option } from '../../../shared/fields/Options'
import { FinancialYearModel } from '../../../models/FinancialYearModel'
import { GUID } from '../../../models/Guid'
import EMDGAccordion from '../../../shared/EMDGAccordion'
import { ApplicantControl } from './Components/Applicant'
import { AgentControl } from './Components/Agent'
import { GRANT_GUIDELINES_URL } from '..'
import { PreviewObj } from '../EligibleApplicantPage'
import { GlobalDataContext } from '../../../GlobalDataContext'
import { ApplicationFetch, OptionItem } from '../../../controllers/ApplicationFetch'

export interface ApplicationFinalisationPageProps {
    history: H.History
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    onSubmit: { (claimAutoNumber: string, blobID: GUID, callback?: { (): any }): any }
    preview?: boolean
    consultants: Consultant[]
    markets: Option<string>[]
    marketsKeyOnly: Option<string>[]
    marketRegions: string[]
    addressCountries: Option<string>[]
    currentApplicationPeriod: FinancialYearModel
    financialYears: Option<string>[]
    eligibleExpenseCategories: Option<string>[]
    previewObj?: PreviewObj
    setPreviewObj?: (updated: Partial<PreviewObj>) => void;
}

export interface ApplicationFinalisationPageState {
    loading: boolean
    submissionError: string
    pdfContent: boolean,
    invalidEmailForAgent: boolean,
    isEligibleAsPerTierYearlyLimit?: boolean,
    priorityTradeAreaDataSource: OptionItem[]
}

export class ApplicationFinalisationPage extends React.Component<ApplicationFinalisationPageProps, ApplicationFinalisationPageState> implements ISupportSpinner {
  static contextType = GlobalDataContext
  context!: React.ContextType<typeof GlobalDataContext>

  ajax: ApplicationController
  applicationFetch = new ApplicationFetch()
  conflictOfInterest: ConflictOfInterest
  bankDetails: BankDetails
  supportingDocumentation: SupportingDocumention
  declaration: Declaration
  previewContent: HTMLDivElement
  submittedErrorDiv: HTMLDivElement
  applicantControl: ApplicantControl
  agentControl: AgentControl

  constructor(props: ApplicationFinalisationPageProps) {
    super(props)

    this.ajax = new ApplicationController()

    this.state = {
      loading: false,
      pdfContent: false,
      submissionError: '',
      invalidEmailForAgent: false,
      priorityTradeAreaDataSource: [],
    }
  }

  componentDidMount() {
    // workaround for missing values in PDF created by 'Submit' button; this is different to PDF "Preview+Print' button;
    const {
      model: {
        applicationTier, isPeakIndustryBody, priorityTradeArea,
      }, setPreviewObj,
    } = this.props
    const selectedTierDisplayName = isPeakIndustryBody
      ? this.context.tierSettingsArr.find((item) => item.isRepBody)?.displayName || '--'
      : this.context.tierSettingsArr.find((item) => item.tierValue.toString() === applicationTier)?.displayName || '--'

    this.applicationFetch.fetchPriorityTradeAreas()
      .then((data: OptionItem[]) => {
        this.setState({ priorityTradeAreaDataSource: data }, () => {
          const priorityTradeAreaDisplayName = this.state.priorityTradeAreaDataSource.find((item) => item.value === priorityTradeArea)?.label || '--'
          if (setPreviewObj) {
            setPreviewObj({
              selectedTierDisplayName,
              priorityTradeAreaDisplayName,
            })
          }
        })
      })
      .catch((error) => {
        console.error('Error fetching priority trade areas:', error)
      })
  }

  submit = async () => {
    const {
      model, model: { abn, applicantModel: { email } }, onSubmit, history, onChange,
    } = this.props
    validateFields(
      async (res) => {
        if (res) {
          const invalidEmailForAgent = model.isConsultant ? await this.validateEmailForAgent(abn, email) : false
          this.setState({ invalidEmailForAgent }, () => {
            if (confirm('You are about to submit the application. Proceed? \n\n You can\'t make any changes once you submit your application.')) {
              this.setState({ pdfContent: true }, () => {
                const content = this.previewContent.innerHTML
                this.setState(
                  { pdfContent: false },
                  () => {
                    const invalidDocuments = getInvalidFileBlobIds(model)
                    const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments }
                    const applicationSubmission: ApplicationSubmission = { model: updatedModel, content }

                    this.ajax.submit(
                      this,
                      applicationSubmission,
                      (response) => {
                        if (response.errorMessage) {
                          this.setState({ submissionError: response.errorMessage })
                        } else {
                          onSubmit(
                            response.autoClaimNumber,
                            response.blobID,
                            () => {
                              onChange({ claimRandomIdentifier: response.autoClaimNumber })
                              history.push(`/reform/${model.applicationID}/submission`)
                            },
                          )
                        }
                      },
                    )
                  },
                )
              })
            }
          })
        }
      },
      this.conflictOfInterest,
      this.supportingDocumentation,
      this.bankDetails,
      this.declaration,
      this.applicantControl,
      this.agentControl,
    )
  }

  validateEmailForAgent = async (abn: string, email: string) => {
    if (!abn || !email) {
      return false
    }
    return new Promise((resolve: (value: boolean) => void, reject): void => {
      this.ajax.validateEmailForAbn(this, abn, email, (res) => {
        resolve(res)
      })
    })
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      model, onChange, history, preview, onSubmit, markets, marketsKeyOnly, marketRegions, consultants,
      addressCountries, currentApplicationPeriod, previewObj, financialYears, eligibleExpenseCategories,
    } = this.props
    const {
      submissionError, loading, pdfContent, invalidEmailForAgent,
    } = this.state
    return (
      <>
        <TabHeading
          label="Application finalisation"
          preview={preview}
        />
        <ConflictOfInterest model={model} onChange={onChange} ref={(r) => { this.conflictOfInterest = r }} preview={preview} />
        <SupportingDocumention model={model} onChange={onChange} ref={(r) => { this.supportingDocumentation = r }} history={history} preview={preview} />
        <BankDetails model={model} onChange={onChange} ref={(r) => { this.bankDetails = r }} preview={preview} />

        {preview && <h4>Primary contact details</h4>}
        <EMDGAccordion header="Primary contact details" expanded>
          <>
            <ApplicantControl
              ref={(r) => { this.applicantControl = r }}
              model={model}
              onChange={(applicantModel) => onChange(applicantModel)}
              addressCountries={addressCountries}
              preview={preview}
              invalidEmailForAgent={invalidEmailForAgent}
            />

            {model.isConsultant && (
              <AgentControl
                ref={(r) => { this.agentControl = r }}
                model={model}
                onChange={(agentModel) => onChange(agentModel)}
                consultants={consultants}
                addressCountries={addressCountries}
                preview={preview}
                visible={model.isConsultant}
              />
            )}
          </>
        </EMDGAccordion>

        <Declaration model={model} onChange={onChange} ref={(r) => { this.declaration = r }} preview={preview} />

        <div tabIndex={-1} ref={(r) => { this.submittedErrorDiv = r }} className="mt-3" style={{ display: submissionError ? '' : 'none' }}>
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            {submissionError === 'TIER_YEARLY_LIMIT_ELIGIBILITY_ERROR' ? (
              <div>
                You are
                {' '}
                <b>not</b>
                {' '}
                eligible to apply for a grant with Austrade for this tier. Tier limits apply from Round 4. See section 4.1.1.5 of the
                {' '}
                <a target="_blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">Grant Guidelines</a>
                {' '}
                for further information.
              </div>
            ) : <div dangerouslySetInnerHTML={{ __html: submissionError }} />}
          </Alert>
        </div>

        <NextBackButtons
          onBack={() => history.push(`/reform/${model.applicationID}/products`)}
          nextLabel="Submit"
          nextDisabled={!model.declarationAppCompleteAccepted}
          onNext={this.submit}
          preview={preview}
        />
        <Backdrop on={loading} />
        {pdfContent && (
        <div ref={(r) => { this.previewContent = r }}>
          <PreviewPage
            model={model}
            onChange={onChange}
            onSubmit={onSubmit}
            history={history}
            markets={markets}
            marketsKeyOnly={marketsKeyOnly}
            marketRegions={marketRegions}
            consultants={consultants}
            addressCountries={addressCountries}
            currentApplicationPeriod={currentApplicationPeriod}
            financialYears={financialYears}
            eligibleExpenseCategories={eligibleExpenseCategories}
            previewObj={previewObj}
          />
        </div>
        )}

      </>
    )
  }
}
